import * as React from 'react';

import {FilestackFilePicker} from '../../../../../filestack-file-picker';
import type {File} from '../../../../../filestack-file-picker';

// @ts-expect-error - imported from .js/.jsx file
import {HtmlAttachmentIcon} from '../icon/svg/html-attachment-icon';

import styles from './filestack-button.module.css';

export type Props = {
    handleFilesUploaded: (arg1: {filesUploaded: File[]}) => void;
    options?: any;
    disabled?: boolean;
    buttonContent?: React.ReactNode;
    isMultiSelect?: boolean;
};

export function FilestackButton(props: Props) {
    const {buttonContent, options, handleFilesUploaded, disabled, isMultiSelect = true} = props;

    return (
        <FilestackFilePicker
            options={options}
            isMultiSelect={isMultiSelect}
            onSuccess={handleFilesUploaded}
            render={({onPick}) => (
                <button
                    type='button'
                    onClick={onPick}
                    disabled={disabled}
                    className={styles['filestack-button']}
                >
                    {buttonContent ? buttonContent : <HtmlAttachmentIcon size={18} />}
                </button>
            )}
        />
    );
}
